module.exports = __webpack_public_path__ + "img/btn-swiper-next.cb36310f.svg";